import store from '../../store/store';
import { resolveObjectPath } from '../../utils/utils';

type AppConfig = {
  API_ENDPOINT: string;
  FRONTEND_VERSION: string;
  AZUREABB2C_CLIENTID: string;
  AZUREADB2C_AUTHORITY: string;
  PLANT_REFRESH_INTERVAL: string;
  AZUREADB2C_KNOWN_AUTHORITY: string;
  AZUREABB2C_FULL_ACCESS_SCOPE: string;
  UI_ENABLED: {
    'room-edit': object | boolean;
    'plant-edit': object | boolean;
    'room-config': object | boolean;
    'plant-delete': object | boolean;
    'scenes-actions': object | boolean;
    'plant-add-room': object | boolean;
    'plant-list-edit': object | boolean;
    'scenes-add-scene': object | boolean;
    'plant-list-delete': object | boolean;
    'room-object-delete': object | boolean;
    'plant-inline-rename': object | boolean;
    'plant-device-settings-edit': object | boolean;
    'plant-server-use-mhs1-only': object | boolean;
    'plant-c300-eos-settings-edit': object | boolean;
    'commands-and-groups-add-group': object | boolean;
    'commands-and-groups-group-actions': object | boolean;
    'plant-room-object-settings-edit-dialog': object | boolean;
    'devices-page-add-device': object | boolean;
    'devices-page-filter-zigbee': object | boolean;
    'plant-edit-image-custom': object | boolean;
    'profile-page': object | boolean;
  };
};

export class UIService {
  gateEditEnabled(): boolean {
    // TODO: handle?
    return true;
  }

  gateDeleteEnabled(): boolean {
    // TODO: handle?
    return true;
  }

  roomEditEnabled(): boolean {
    return this.checkSectionEnabled('room-edit');
  }

  plantEditEnabled(): boolean {
    return this.checkSectionEnabled('plant-edit');
  }

  roomConfigEnabled(): boolean {
    return this.checkSectionEnabled('room-config');
  }

  plantDeleteEnabled(): boolean {
    return this.checkSectionEnabled('plant-delete');
  }

  plantAddRoomEnabled(): boolean {
    return this.checkSectionEnabled('plant-add-room');
  }

  scenesActionsEnabled(): boolean {
    return this.checkSectionEnabled('scenes-actions');
  }

  scenesAddSceneEnabled(): boolean {
    return this.checkSectionEnabled('scenes-add-scene');
  }

  plantEditListEnabled(): boolean {
    return this.checkSectionEnabled('plant-list-edit');
  }

  plantDeleteListEnabled(): boolean {
    return this.checkSectionEnabled('plant-list-delete');
  }

  roomObjectDeleteEnabled(): any {
    return this.checkSectionEnabled('room-object-delete');
  }

  plantInlineRenameEnabled(): boolean {
    return this.checkSectionEnabled('plant-inline-rename');
  }

  plantDeviceSettingsEditEnabled(): boolean {
    return this.checkSectionEnabled('plant-device-settings-edit');
  }

  plantServerUseMHS1Only(): boolean {
    return this.checkSectionEnabled('plant-server-use-mhs1-only');
  }

  plantC300EosSettingsEditEnabled(): any {
    return this.checkSectionEnabled('plant-c300-eos-settings-edit');
  }

  commandsAndGroupsAddGroupEnabled(): boolean {
    return this.checkSectionEnabled('commands-and-groups-add-group');
  }

  commandsAndGroupsGroupActionsEnabled(): boolean {
    return this.checkSectionEnabled('commands-and-groups-group-actions');
  }

  plantRoomObjectSettingsEditDialog(): boolean {
    return this.checkSectionEnabled('plant-room-object-settings-edit-dialog');
  }

  devicesPageAddDeviceEnabled(): boolean {
    return this.checkSectionEnabled('devices-page-add-device');
  }

  devicesPageFilterZigbeeEnabled(): boolean {
    return this.checkSectionEnabled('devices-page-filter-zigbee');
  }

  plantEditImageCustomEnabled(): boolean {
    return this.checkSectionEnabled('plant-edit-image-custom');
  }

  profilePageEnabled(): boolean {
    return this.checkSectionEnabled('profile-page');
  }

  private checkSectionEnabled(
    sectionKey: keyof AppConfig['UI_ENABLED']
  ): boolean {
    const APP_CONFIG = ((window as any).appConfig as AppConfig) ?? {};
    if (
      !APP_CONFIG.UI_ENABLED ||
      APP_CONFIG.UI_ENABLED[sectionKey] === undefined
    )
      return false;
    if (typeof APP_CONFIG.UI_ENABLED[sectionKey] === 'boolean')
      return APP_CONFIG.UI_ENABLED[sectionKey] as boolean;

    const results: boolean[] = [];
    Object.keys(APP_CONFIG.UI_ENABLED[sectionKey]).forEach((rule) => {
      const sectionKeyValue = resolveObjectPath(store.state, rule);
      results.push(
        sectionKeyValue === (APP_CONFIG.UI_ENABLED[sectionKey] as any)[rule]
      );
    });
    return results.some((r) => !!r);
  }
}
